/* Editorial PDP header (Justin 2026-07-24 mock) — the five NT-engine templates:
 * uv-by-size-imgix, dtf-gang-imgix, uv-gang-imgix, dtf-builder-v2, uv-builder-v2.
 * (dtf-imgix gets the same look natively via bysize-v4 blocks + skin.)
 *
 * Does three things, all presentation-only:
 *  1. Title accent — wraps the trailing phrase ("By Size" / "Gang Sheets" /
 *     "Builder") of the product H1 in <span class="nt-t-accent"> (brand blue).
 *  2. Numbered benefit rows — reshapes the .buyMoreSave strip's three items
 *     into 01/02/03 editorial rows with grey detail copy (map below).
 *  3. Styling hooks only; all colors/layout live in nt-editorial-header.css.
 */
(function () {
  'use strict';

  var bc = (document.body && document.body.className) || '';
  if (!/template-product-(build-a-gang-sheet|dtf-gang-sheet|by-size-bg-options|uv-gang-imgix)|nt-gs-sheet/.test(bc)) return;

  /* trailing-phrase accent, longest match first */
  var PHRASES = [/\b(by size)$/i, /\b(gang sheet builder)$/i, /\b(builder)$/i, /\b(gang sheets)$/i];
  function accentTitle() {
    var h1 = document.querySelector('.product-text h1.product__title, .product-text .product__title');
    if (!h1 || h1.querySelector('.nt-t-accent')) return;
    var walker = h1.childNodes;
    for (var i = walker.length - 1; i >= 0; i--) {
      var n = walker[i];
      if (n.nodeType !== 3 || !n.textContent.trim()) continue;
      var txt = n.textContent.replace(/\s+$/, '');
      for (var p = 0; p < PHRASES.length; p++) {
        var m = txt.match(PHRASES[p]);
        if (m) {
          var idx = txt.length - m[1].length;
          var span = document.createElement('span');
          span.className = 'nt-t-accent';
          span.textContent = txt.slice(idx);
          var before = document.createTextNode(txt.slice(0, idx));
          h1.replaceChild(span, n);
          h1.insertBefore(before, span);
          return;
        }
      }
      return; /* only inspect the last real text node */
    }
  }

  /* benefit-row detail copy. Gang + builder templates carry their own row-1
     line (no cumulative discounts on gang sheets — Justin 2026-07-24 spec). */
  var IS_GANG = /nt-gs-sheet|template-product-build-a-gang-sheet/.test(bc);
  var SUBS = {
    save: IS_GANG ? 'best priced discounts on largest gang sheets' : 'cumulative discounts across your order',
    ship: 'off the press within 24 hours',
    fees: 'order one or a thousand'
  };

  /* Uniform selling-point titles. Gang spec (exact): "Buy More & Save Up To 67%",
     "No Minimums, Setup or Art Fees". Row 2 text is CSS-owned (::before). */
  function normalizeRows() {
    var bms = document.querySelector('.product-text .buyMoreSave[data-nt-editorial]');
    if (!bms) return;
    var title = bms.querySelector('.buyMoreSave__title');
    if (title) {
      var want;
      if (IS_GANG) {
        want = 'Buy More & Save Up To 67%';
      } else {
        var pm = (title.textContent || '').match(/(\d+)\s*%/);
        want = 'Buy more & save up to ' + (pm ? pm[1] : '50') + '%';
      }
      if (title.textContent.trim() !== want) title.textContent = want;
      var row1 = title.closest ? title.closest('.nt-ed-row') : null;
      var sub1 = row1 && row1.querySelector('.nt-ed-sub');
      if (sub1 && sub1.textContent !== SUBS.save) sub1.textContent = SUBS.save;
    }
    var fees = bms.querySelector('.buyMoreSave__noMinimum');
    var feesWant = IS_GANG ? 'No Minimums, Setup or Art Fees' : 'No minimum, setup or art fees';
    if (fees && fees.textContent.trim() !== feesWant) fees.textContent = feesWant;
  }
  function editorialRows() {
    var bms = document.querySelector('.product-text .buyMoreSave:not([data-nt-editorial])'); /* v2 tiles included — editorial rows are the final spec */
    if (!bms) return;
    var title = bms.querySelector('.buyMoreSave__title');
    var ship = bms.querySelector('fastest-deliver-placeholder');
    var fees = bms.querySelector('.buyMoreSave__noMinimum');
    if (!title || !fees) return;
    bms.setAttribute('data-nt-editorial', '1');
    var rows = [
      { el: title, num: '01', sub: SUBS.save },
      { el: ship, num: '02', sub: SUBS.ship },
      { el: fees, num: '03', sub: SUBS.fees }
    ];
    rows.forEach(function (r) {
      if (!r.el) return;
      var row = document.createElement('span');
      row.className = 'nt-ed-row';
      var num = document.createElement('span');
      num.className = 'nt-ed-num';
      num.textContent = r.num;
      var sub = document.createElement('span');
      sub.className = 'nt-ed-sub';
      sub.textContent = r.sub;
      r.el.parentNode.insertBefore(row, r.el);
      row.appendChild(num);
      row.appendChild(r.el);
      row.appendChild(sub);
    });
  }

  /* Builder size pills: condense labels so all sizes fit one line
     ("22 in X 240 in (20 ft)" -> "22\u2033 \u00d7 240\u2033 (20 ft)"). Inputs keep their
     original VALUES — only the visible label text changes. */
  function condensePills() {
    if (!/template-product-build-a-gang-sheet/.test(bc)) return;
    var labels = document.querySelectorAll('.product-variant__container[option="1"] .product-variant__item--radio label');
    for (var i = 0; i < labels.length; i++) {
      var lb = labels[i];
      if (lb.getAttribute('data-nt-condensed')) continue;
      for (var n = 0; n < lb.childNodes.length; n++) {
        var node = lb.childNodes[n];
        if (node.nodeType === 3 && /\d\s*in\b/i.test(node.textContent)) {
          node.textContent = node.textContent
            .replace(/(\d+(?:\.\d+)?)\s*in\b/gi, '$1\u2033')
            .replace(/\s+[xX]\s+/, ' \u00d7 ');
        }
      }
      lb.setAttribute('data-nt-condensed', '1');
    }
  }

  /* Uniform meta line under the H1 on every PDP:
     "From $0.02 / sq in \u00b7 printed & shipped in the USA" ($0.03 on UV pages).
     The engine "As Low As" line is rewritten by infoLine(); the injector's
     [data-nt-info-row] is HIDDEN via CSS (it rebuilds itself async and can't
     be normalized reliably) and this clean line replaces it. */
  /* Engine "As Low As - $X per square inch." line -> dtf-imgix meta format */
  function infoLine() {
    var els = document.querySelectorAll('.product-text ._flex-box');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.closest && el.closest('[data-nt-info-row]')) continue;
      if (el.offsetParent === null) continue;
      if (el.getAttribute('data-nt-editorial-info')) return;
      if (!/as low as/i.test(el.textContent || '')) continue;
      var pm = (el.textContent || '').match(/\$\s*([\d.]+)/);
      if (!pm) return;
      el.textContent = '';
      var lead = document.createElement('strong');
      lead.className = 'nt-info-lead';
      lead.textContent = 'From $' + pm[1] + ' / sq in';
      var tail = document.createElement('span');
      tail.className = 'nt-info-tail';
      tail.textContent = ' \u00b7 printed & shipped in the USA';
      el.appendChild(lead);
      el.appendChild(tail);
      el.setAttribute('data-nt-editorial-info', '1');
      return;
    }
  }

  function ensureMetaLine() {
    var isUv = /build-a-gang-sheet-uv|uv-gang|uv-builder|uv-dtf/.test(bc);
    var wantLead = 'From $' + (isUv ? '0.03' : '0.02') + ' / sq in';
    var existing = document.querySelector('.product-text .nt-meta-line[data-nt-editorial-info]');
    if (existing) {
      /* self-heal if any engine script rewrote our content */
      if (!/printed & shipped/.test(existing.textContent) || existing.textContent.indexOf(' / sq in') === -1) {
        existing.textContent = '';
        var lead2 = document.createElement('strong');
        lead2.className = 'nt-info-lead';
        lead2.textContent = wantLead;
        var tail2 = document.createElement('span');
        tail2.className = 'nt-info-tail';
        tail2.textContent = ' \u00b7 printed & shipped in the USA';
        existing.appendChild(lead2);
        existing.appendChild(tail2);
      }
      return;
    }
    var marked = document.querySelectorAll('.product-text ._flex-box[data-nt-editorial-info]');
    for (var m = 0; m < marked.length; m++) {
      if (marked[m].closest && marked[m].closest('[data-nt-info-row]')) continue;
      if (marked[m].offsetParent === null) continue; /* hidden by the engine — doesn't count */
      return; /* live visible engine line */
    }
    var flexes = document.querySelectorAll('.product-text ._flex-box');
    for (var i = 0; i < flexes.length; i++) {
      if (flexes[i].closest && flexes[i].closest('[data-nt-info-row]')) continue;
      if (flexes[i].offsetParent === null) continue;
      if (/as low as/i.test(flexes[i].textContent || '')) return; /* infoLine() handles it */
    }
    var h1 = document.querySelector('.product-text h1.product__title, .product-text .product__title');
    if (!h1) return;
    var line = document.createElement('div');
    line.className = 'nt-meta-line'; /* NOT _flex-box — the injector rewrites those */
    line.setAttribute('data-nt-editorial-info', '1');
    var lead = document.createElement('strong');
    lead.className = 'nt-info-lead';
    lead.textContent = wantLead;
    var tail = document.createElement('span');
    tail.className = 'nt-info-tail';
    tail.textContent = ' \u00b7 printed & shipped in the USA';
    line.appendChild(lead);
    line.appendChild(tail);
    h1.parentNode.insertBefore(line, h1.nextSibling);
  }

  /* Gang pages: height labels show just the size ("2 Feet", "6 Inches"),
     not the full "22 in X 24 in (2 Feet)" variant string. Display-only. */
  function gangHeightLabels() {
    if (!/nt-gs-sheet/.test(bc)) return;
    var nodes = document.querySelectorAll('.gangSheet__dropdown, .gangSheet__dropdown *');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      for (var c = 0; c < el.childNodes.length; c++) {
        var n = el.childNodes[c];
        if (n.nodeType !== 3) continue;
        var txt = n.textContent;
        if (!/22\s*in/i.test(txt)) continue;
        var m = txt.match(/\(([^)]+)\)/);
        var out = null;
        if (m) {
          out = m[1].replace(/\bft\b/i, 'Feet').replace(/^1 Feet$/i, '1 Foot');
        } else {
          var mi = txt.match(/[xX]\s*([\d.]+)\s*in/);
          if (mi) out = mi[1] + ' Inches';
        }
        if (out && txt.trim() !== out) n.textContent = out;
      }
    }
  }

  /* Preview dim labels paint "NaN\"" on gang pages — the NT engine reads
     data-width/data-height attrs off the variant radios, which this store's
     variants don't carry. Derive from the detected sheet size instead
     (sheets are always 22" wide; height from the dropdown label). */
  function fixNaNDims() {
    if (!/nt-gs-sheet/.test(bc)) return;
    var v = document.querySelector('.verticle_direction span');
    var h = document.querySelector('.horizontal_direction span');
    var sel = document.querySelector('.gangSheet__item.selectedTier .gangSheet__dropdown') ||
              document.querySelector('.gangSheet__dropdown');
    var inches = null, m;
    if (sel) {
      var t = sel.textContent || '';
      if ((m = t.match(/([\d.]+)\s*Inches/i))) inches = parseFloat(m[1]);
      else if ((m = t.match(/([\d.]+)\s*Feet/i))) inches = parseFloat(m[1]) * 12;
      else if (/1\s*Foot/i.test(t)) inches = 12;
      else if ((m = t.match(/[xX]\s*([\d.]+)\s*in/))) inches = parseFloat(m[1]);
    }
    if (v && /NaN/.test(v.textContent) && inches) v.textContent = inches + '"';
    if (h && /NaN/.test(h.textContent)) h.textContent = '22"';
  }

  /* Builder mobile (Justin 2026-07-25 uniformity): show the same numbered
     rows as gang/by-size, not the v2 icon tiles. The tile CSS hides the
     strip from inside an @layer, whose !important outranks any unlayered
     stylesheet rule — inline style importants are the only clean counter. */
  var mobMq = window.matchMedia('(max-width: 999px)');
  function mobileBuilderRows() {
    if (!/template-product-build-a-gang-sheet/.test(bc)) return;
    var mob = mobMq.matches;
    var bms = document.querySelector('.product-text .buyMoreSave[data-nt-editorial]');
    if (bms) {
      if (mob && bms.style.display !== 'block') bms.style.setProperty('display', 'block', 'important');
      if (!mob && bms.style.display === 'block') bms.style.removeProperty('display');
    }
    var tiles = document.querySelectorAll('.product-text .nt-bms-v2');
    for (var i = 0; i < tiles.length; i++) {
      if (mob && tiles[i].style.display !== 'none') tiles[i].style.setProperty('display', 'none', 'important');
      if (!mob && tiles[i].style.display === 'none') tiles[i].style.removeProperty('display');
    }
  }
  try { mobMq.addEventListener('change', function () { mobileBuilderRows(); }); } catch (e) {}

  /* Gang checkout unlock (Justin 2026-07-25 bug): the NT section only removes
     the .__validate_upload wrapper (which pointer-events:none's the checkout
     button) from a CloudLift checkbox handler — and this store has no
     CloudLift, so the visible .gangsheet_terms box unlocked nothing. Bridge:
     sync duplicate term boxes (premium renders two step blocks) and reconcile
     the wrapper from the real box + body.image-uploaded. */
  function gangTermsBridge() {
    if (!/nt-gs-sheet/.test(bc)) return;
    var boxes = document.querySelectorAll('.gangsheet_terms input[type="checkbox"]');
    if (!boxes.length) return;
    for (var j = 0; j < boxes.length; j++) {
      if (boxes[j].getAttribute('data-nt-terms-wired')) continue;
      boxes[j].setAttribute('data-nt-terms-wired', '1');
      boxes[j].addEventListener('change', function () {
        var on = this.checked;
        var all = document.querySelectorAll('.gangsheet_terms input[type="checkbox"]');
        for (var k = 0; k < all.length; k++) { if (all[k].checked !== on) all[k].checked = on; }
        gangTermsBridge();
      });
    }
    var anyChecked = false;
    for (var i = 0; i < boxes.length; i++) { if (boxes[i].checked) { anyChecked = true; break; } }
    var uploaded = document.body.classList.contains('image-uploaded');
    var w;
    if (anyChecked && uploaded) {
      var wraps = document.querySelectorAll('.__validate_upload');
      for (w = 0; w < wraps.length; w++) wraps[w].classList.remove('__validate_upload');
      var errs = document.querySelectorAll('.__uploaderror');
      for (w = 0; w < errs.length; w++) errs[w].parentNode && errs[w].parentNode.removeChild(errs[w]);
    } else if (!anyChecked) {
      var cases = document.querySelectorAll('.__errorcase');
      for (w = 0; w < cases.length; w++) cases[w].classList.add('__validate_upload');
    }
  }

  /* Gang checkout submit guard (Justin 2026-07-25): a third-party listener on
     the add-to-cart button (CloudLift's app JS still loads on this store)
     swallows the click before the form ever dispatches submit — cart add
     never fires. Capture on the FORM runs before any button-level listener:
     when our validations pass, stop the rogue handler and submit natively
     (requestSubmit → ProductForm's own AJAX add). */
  function gangSubmitGuard() {
    if (!/nt-gs-sheet/.test(bc)) return;
    var btn = document.querySelector('.add-to-cart[data-main-product-add-to-cart]');
    var form = btn && btn.closest('form');
    if (!form || form.getAttribute('data-nt-submit-guard')) return;
    form.setAttribute('data-nt-submit-guard', '1');
    form.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.add-to-cart[data-main-product-add-to-cart]');
      if (!b) return;
      if (b.closest('.__validate_upload')) return; /* terms/upload errors own this click */
      if (!document.body.classList.contains('image-uploaded')) return;
      e.stopPropagation();
      e.preventDefault();
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    }, true);
  }

  function run() {
    [accentTitle, editorialRows, normalizeRows, infoLine, ensureMetaLine, condensePills, gangHeightLabels, fixNaNDims, mobileBuilderRows, gangTermsBridge, gangSubmitGuard].forEach(function (fn) {
      try { fn(); } catch (e) { /* keep the rest running */ }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  /* engines render pieces late (sometimes well past page load) — observe and
     re-apply idempotently for the page's lifetime, debounced. */
  var moT = null;
  var mo = new MutationObserver(function () {
    if (moT) return;
    moT = setTimeout(function () { moT = null; run(); }, 180);
  });
  function arm() { try { mo.observe(document.body, { childList: true, subtree: true }); } catch (e) {} }
  if (document.body) arm();
  else document.addEventListener('DOMContentLoaded', arm);
})();
